import TopNav from './TopNav';

export type { TopNavSearchConfig } from './TopNav';
export default TopNav;
